import React, { useState } from 'react';
import './App.css';
import { GameProvider } from './contexts/GameContext';
import GameSetup from './components/GameSetup';
import GameBoard from './components/GameBoard';

function App() {
  const [gameMode, setGameMode] = useState(null); // 'wheel' or 'cards'

  return (
    <div className="App">
      <header className="App-header">
        <h1>Erotic Game</h1>
      </header>

      <GameProvider>
        {!gameMode ? (
          <GameSetup setGameMode={setGameMode} />
        ) : (
          <GameBoard gameMode={gameMode} setGameMode={setGameMode} />
        )}
      </GameProvider>
    </div>
  );
}

export default App;